import { gsap }          from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger.js';

gsap.registerPlugin(ScrollTrigger);

const anim = () => {
    // ===== HARD RESET =====
    ScrollTrigger.getAll().forEach((st) => st.kill());
    gsap.killTweensOf('*');

    // ===== DATA SCROLL ANIMATE =====
    [...document.querySelectorAll('[data-scroll-animate]')]
        .filter((el) => document.body.contains(el))
        .forEach((item) => {
            let cfg;
            try {
                cfg = JSON.parse(item.dataset.scrollAnimate);
            } catch {
                return;
            }

            const tl = gsap.timeline({
                scrollTrigger : {
                    trigger : item,
                    start   : 'top bottom-=100',
                    once    : true
                }
            });

            tl.from(item, {
                x        : cfg.x ?? 0,
                y        : cfg.y ?? 0,
                opacity  : cfg.opacity ?? 1,
                duration : cfg.duration ?? 1,
                delay    : cfg.delay ?? 0,
                ease     : 'power1.out'
            });

            if (cfg.border) {
                let originalBorderColor = getComputedStyle(item).borderBottomColor;

                if (!originalBorderColor || originalBorderColor === 'rgba(0, 0, 0, 0)' || originalBorderColor === 'transparent') {
                    originalBorderColor = '#e0e0e0';
                }

                item.style.borderBottomColor = 'transparent';

                tl.to(item, {
                    borderBottomColor : originalBorderColor,
                    duration          : cfg.border.duration ?? 0.5,
                    ease              : 'power2.out'
                }, '-=0.3');
            }
        });
};

export default anim;
